let PROTOCOL = process.env.NEXT_PUBLIC_BASE_PROTOCOL;
let BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
let SOCKET_URL = process.env.NEXT_PUBLIC_SOCKET_URL;
let MAIN_URL = PROTOCOL + process.env.NEXT_PUBLIC_BASE_URL;
let API_VERSION_PREFIX = '/api';
let API_VERSION_PREFIX_V1 = '/api/v1';
let SOCKET_PROTOCOL = process.env.NEXT_PUBLIC_BASE_SOCKET_PROTOCOL;
let PWA_URL = process.env.NEXT_PUBLIC_PWA_BASE_URL;

export default {
    SOCKET_URL: SOCKET_URL,
    BASE_URL: BASE_URL,
    MAIN_URL: MAIN_URL,
    GET_FILES: MAIN_URL,
    SOCKET_PROTOCOL: SOCKET_PROTOCOL,
    PWA_URL: PROTOCOL + PWA_URL,

    SESSION_LOGIN: MAIN_URL + API_VERSION_PREFIX + '/users/login/',
    SESSION_MFA_LOGIN: MAIN_URL + API_VERSION_PREFIX + '/users/verify_mfa_token/',
    SESSION_LOGIN_OAUTH_PROVIDERS: MAIN_URL + '/v1/core/sessions/external-providers',
    SESSION_LOGIN_OAUTH: MAIN_URL + '/v1/core/sessions/using-external-provider',
    SESSION_GET_INFO: MAIN_URL + API_VERSION_PREFIX + '/users/profile/me/',

    USER_SIGNUP: MAIN_URL + API_VERSION_PREFIX + '/users/register/',
    USER_INVITE: MAIN_URL + API_VERSION_PREFIX + '/users/invite_code/',
    USER_INVITE_STATISTICS: MAIN_URL + API_VERSION_PREFIX + '/users/invite_code/statistics/',
    USER_REQUEST_VERIFY: MAIN_URL + API_VERSION_PREFIX + '/users/verify_user/',

    // + V1
    VERIFY_TOKEN_REQUEST: MAIN_URL + API_VERSION_PREFIX + '/users/verify_token_request/',
    VERIFY_TOKEN_CONFIRM: MAIN_URL + API_VERSION_PREFIX + '/users/verify_token_confirm/',
    // - V1

    USER_REQUEST_VERIFY_TOKEN: MAIN_URL + API_VERSION_PREFIX + '/users/verify_user_token/',
    USER_UPGRADE_REQUEST: MAIN_URL + API_VERSION_PREFIX + '/users/upgrade_request/',
    USER_ENABLE_MFA: MAIN_URL + API_VERSION_PREFIX + '/users/toggle_user_mfa/',
    USER_CONFIRM_MFA_ACTION: MAIN_URL + API_VERSION_PREFIX + '/users/confirm_user_mfa/',
    USER_RESEND_MFA_ACTION: MAIN_URL + API_VERSION_PREFIX + '/users/resend_mfa_token/',
    USER_VERIFY_OWNERSHIP: MAIN_URL + API_VERSION_PREFIX + '/users/verify_mobile_ownership/',
    USER_SET_FIRST_PASSWD: MAIN_URL + API_VERSION_PREFIX + '/users/set_password/',
    USER_CHANGE_PASSWD: MAIN_URL + API_VERSION_PREFIX + '/users/change_password/',
    USER_QUICK_AUTH: MAIN_URL + API_VERSION_PREFIX + '/users/quick_auth/',
    USER_CHANGE_PHONE_NUMBER: MAIN_URL + API_VERSION_PREFIX + '/users/change_phone_number/',

    // + V1
    USER_RESET_PASSWD_REQUEST: MAIN_URL + API_VERSION_PREFIX + '/users/reset_password_request/',
    USER_RESET_PASSWD_CONFIRM: MAIN_URL + API_VERSION_PREFIX + '/users/reset_password_confirm/',
    // - V1

    USER_RESET_PASSWD: MAIN_URL + API_VERSION_PREFIX + '/users/reset_password/',
    USER_SET_PASSWD: MAIN_URL + API_VERSION_PREFIX + '/users/confirm_reset_password/',
    USER_ACCESS: MAIN_URL + API_VERSION_PREFIX + '/users/get_access_token/',

    CRYPTO_WALLETS: MAIN_URL + API_VERSION_PREFIX + '/crypto/wallet/',
    CRYPTO_ACTIVE_CRYPOS: MAIN_URL + API_VERSION_PREFIX + '/crypto/currency/',
    CRYPTO_ACTIVE_CRYPOS_INFO: MAIN_URL + API_VERSION_PREFIX + '/crypto/currency/currencies_info/',
    CRYPTO_WALLET_CREATE: MAIN_URL + API_VERSION_PREFIX + '/crypto/wallet/{symbol_or_pk}/create_wallet/',
    CRYPTO_WALLET_CREATE_WITH_RETURN: MAIN_URL + API_VERSION_PREFIX + '/crypto/wallet/{symbol_or_pk}/create_wallet/?with_wallet=1',
    CRYPTO_WALLET_INFO: MAIN_URL + API_VERSION_PREFIX + '/crypto/wallet/{symbol_or_pk}/',
    CRYPTO_WALLET_REWARDS: MAIN_URL + API_VERSION_PREFIX + '/crypto/reward/',
    CRYPTO_WALLET_REWARD: MAIN_URL + API_VERSION_PREFIX + '/crypto/reward/{symbol_or_pk}/',
    CRYPTO_WALLET_TRANSACTIONS: MAIN_URL + API_VERSION_PREFIX + '/crypto/transaction/',
    CRYPTO_WALLET_TRANSACTION: MAIN_URL + API_VERSION_PREFIX + '/crypto/transaction/{symbol_or_pk}/',
    CRYPTO_WALLET_EXTERNAL_TRANSACTIONS: MAIN_URL + API_VERSION_PREFIX + '/crypto/external_transaction/',
    CRYPTO_WALLET_EXTERNAL_TRANSACTION: MAIN_URL + API_VERSION_PREFIX + '/crypto/external_transaction/{symbol_or_pk}/',
    CRYPTO_WALLET_WITHDRAW_REQUEST: MAIN_URL + API_VERSION_PREFIX + '/crypto/external_transaction/withdraw_request/',
    CRYPTO_WALLET_WITHDRAW_VERIFY: MAIN_URL + API_VERSION_PREFIX + '/crypto/external_transaction/verify_withdraw_request/',
    CRYPTO_WALLET_SYNC: MAIN_URL + API_VERSION_PREFIX + '/crypto/external_transaction/sync_wallet/',
    CRYPTO_COMMISSIONS: MAIN_URL + API_VERSION_PREFIX + '/crypto/wallet/commissions/',

    // + V1
    CRYPTO_CURRENCIES: MAIN_URL + API_VERSION_PREFIX_V1 + '/crypto/currency/info/',
    CRYPTO_WALLETS_V1: MAIN_URL + API_VERSION_PREFIX_V1 + '/crypto/wallet/',
    // - V1

    TRADING: MAIN_URL + API_VERSION_PREFIX + '/trading/',
    TRADING_GET: MAIN_URL + API_VERSION_PREFIX + '/trading/{id}/',
    TRADING_DELETE: MAIN_URL + API_VERSION_PREFIX + '/trading/{id}/',
    TRADING_DELETE_ALL: MAIN_URL + API_VERSION_PREFIX + '/trading/delete_user_trades/',
    TRADING_GET_ALL: MAIN_URL + API_VERSION_PREFIX + '/trading/',
    TRADING_GET_MARKET_BY_ID: MAIN_URL + API_VERSION_PREFIX + '/trading/market/{id}/',
    TRADING_GET_MARKETS: MAIN_URL + API_VERSION_PREFIX + '/trading/market/',
    TRADING_GET_MARKETS_SOON: MAIN_URL + API_VERSION_PREFIX + '/trading/market/soon/',
    TRADING_GET_MARKET_ORDERS: MAIN_URL + API_VERSION_PREFIX + '/trading/get_trades_by_market/',
    TRADING_GET_MARKET_ORDERS_DETAILS: MAIN_URL + API_VERSION_PREFIX + '/trading/get_trade_details_by_market/',
    TRADING_GET_TRADES_FEE: MAIN_URL + API_VERSION_PREFIX + '/trading/get_trades_fee/',
    TRADING_FEE_PLANS: MAIN_URL + API_VERSION_PREFIX + '/trading/fee_plans/',
    TRADING_USER_FEE: MAIN_URL + API_VERSION_PREFIX + '/trading/user_fee/',
    TRADING_GET_OPEN_REQUESTS: MAIN_URL + API_VERSION_PREFIX + '/trading/get_open_requests/',
    TRADING_TRANSACTIONS: MAIN_URL + API_VERSION_PREFIX + '/trading/transaction/',
    TRADING_TRANSACTION_ONE: MAIN_URL + API_VERSION_PREFIX + '/trading/transaction/{id}/',
    TRADING_MARKET_PRICES: MAIN_URL + API_VERSION_PREFIX + '/trading/market/prices/',
    TRADING_MARKET_BOOKMARK: MAIN_URL + API_VERSION_PREFIX + '/trading/market/bookmark/',

    // + V1
    TRADING_USER_ACTIVE_TRADES: MAIN_URL + API_VERSION_PREFIX + '/trading/user_active_trades/',
    // - V1

    ACCOUNTING: MAIN_URL + API_VERSION_PREFIX + '/payment/',
    ACCOUNTING_LIST: MAIN_URL + API_VERSION_PREFIX + '/accounting/',
    ACCOUNTING_GET_ONE: MAIN_URL + API_VERSION_PREFIX + '/accounting/{id}/',
    ACCOUNTING_WITHDRAW: MAIN_URL + API_VERSION_PREFIX + '/accounting/withdraw/',
    ACCOUNTING_WITHDRAW_VERIFY: MAIN_URL + API_VERSION_PREFIX + '/accounting/withdraw/verify_withdraw_token/',
    ACCOUNTING_WITHDRAW_LIST: MAIN_URL + API_VERSION_PREFIX + '/accounting/withdraw/',
    ACCOUNTING_BALANCE: MAIN_URL + API_VERSION_PREFIX + '/accounting/get_balance/',
    ACCOUNTING_GET_PLAN_DETAILS: MAIN_URL + API_VERSION_PREFIX + '/accounting/get_user_transactions_status/',
    ACCOUNTING_CREDIT_CARDS: MAIN_URL + API_VERSION_PREFIX + '/accounting/credit_card/',
    ACCOUNTING_IBAN: MAIN_URL + API_VERSION_PREFIX + '/accounting/iban/',
    ACCOUNTING_DELETE_CREDIT_CARDS: MAIN_URL + API_VERSION_PREFIX + '/accounting/credit_card/{id}/',
    ACCOUNT_COMMISSIONS: MAIN_URL + API_VERSION_PREFIX + '/accounting/commissions/',
    ACCOUNTING_CHANGE_FEE_PLAN: MAIN_URL + API_VERSION_PREFIX + '/accounting/change_fee_plan/',

    // + V4
    USER_TRANSACTION: MAIN_URL + '/api/v4/user-transaction/{id}',

    // + V1
    FIAT_TRANSACTION_LIST: MAIN_URL + API_VERSION_PREFIX_V1 + '/accounting/',
    PAYMENT: MAIN_URL + API_VERSION_PREFIX_V1 + '/accounting/deposit/',
    // - V1

    // + V1
    USER_CREDIT_CARDS: MAIN_URL + API_VERSION_PREFIX_V1 + '/accounting/credit_card/',
    // - V1

    TICKET_CATEGORY: MAIN_URL + API_VERSION_PREFIX + '/ticketing/category/',
    TICKET_CREATE: MAIN_URL + API_VERSION_PREFIX + '/ticketing/',
    TICKET_GET_OPEN: MAIN_URL + API_VERSION_PREFIX + '/ticketing/',
    TICKET_GET_ONE: MAIN_URL + API_VERSION_PREFIX + '/ticketing/{id}/',
    TICKET_COMMENT: MAIN_URL + API_VERSION_PREFIX + '/ticketing/comment/',
    TICKET_GET_COMMENT: MAIN_URL + API_VERSION_PREFIX + '/ticketing/comment/',

    CAMPAIGN: MAIN_URL + API_VERSION_PREFIX + '/campaign/',
    CAMPAIGN_REGISTER: MAIN_URL + API_VERSION_PREFIX + '/campaign/register/',
    CAMPAIGN_ACTIONS: MAIN_URL + API_VERSION_PREFIX + '/campaign/actions/',
    CAMPAIGN_POINTS: MAIN_URL + API_VERSION_PREFIX + '/campaign/points/',

    CAPTCHA: MAIN_URL + API_VERSION_PREFIX + '/captcha/',

    UPLOAD: MAIN_URL + API_VERSION_PREFIX + '/files/',

    BANK: MAIN_URL + API_VERSION_PREFIX + '/bank/',

    NOTIFICATION_GET_ALL: MAIN_URL + API_VERSION_PREFIX + '/notifications/',
    NOTIFICATION_MARK_AS_READ: MAIN_URL + API_VERSION_PREFIX + '/notifications/mark_as_read/',
    NOTIFICATION_UNREAD_COUNT: MAIN_URL + API_VERSION_PREFIX + '/notifications/unread_count/',

    REPORT: MAIN_URL + API_VERSION_PREFIX_V1 + '/accounting/report_card/',
    ADDITIONAL_INFO: MAIN_URL + '/api/users/profile/additional_info/',

    DETECTOR: 'https://echo.pingi.co/',
};
